export default "https://cdn-static.gokick.com/assets/9df01a4d731a00226137dd4d749df43ffc1d6e8e/images/citrus-zen.3d089e3f253b955a4e1c4ecfa30a73d4.png";